import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';

export const quotePartAddToPricingProfileSchema = () =>
  yup.object().shape({
    pricingProfile: yup
      .object()
      .label(t('labelPricingProfile'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelPricingProfile'))),
    pricingOptions: yup
      .string()
      .nullable()
      .when('cost', {
        is: false,
        then: yup.string().nullable().required(t('errorSelectPriceMarginCost')),
      }),
    cost: yup.boolean().nullable(),
  });
